/*
 * @Description:
 * @Author:  bean^ <bean_4@163.com>
 * @Date: 2020-10-29 10:57:10
 * @LastEditors: bean
 * @LastEditTime: 2021-05-06 17:54:41
 */
import Axios from 'axios'
//import {baseURL} from 'config/index'


const METHODS = {GET: 'get', POST: 'post'}

const ERROR_TYPE = {
    ERROR_HTTP_RESULT: 'ERROR_HTTP_RESULT',
    ERROR_HTTP_REQUEST_TIMEOUT: '请求超时，请检查网络是否连接正常',
    ERROR_HTTP_REQUEST_FAIL: '网络异常，请稍后重试',
    ERROR_HTTP_LINK: '网络请求不存在',
    ERROR_LOGIN_TIMEOUT: '登录信息过期，请重新登录',
    ERROR_LOGIN_STATUS: '你还未登录，请登录后进行操作',
    ERROR_COMMON: '系统繁忙，请稍后重试',
    ERROR_DATA_FORMAT: '数据格式错误',
    ERROR_JUMP_URL: '页面出了一点小问题，去其它页面看看吧',
}
const ERROR_CODE = [
    {code: '401', msg: ERROR_TYPE.ERROR_LOGIN_STATUS},
    {code: '403', msg: ERROR_TYPE.ERROR_LOGIN_TIMEOUT},
    {code: '404', msg: ERROR_TYPE.ERROR_HTTP_LINK},
]

const showMsg = (msg) => {
    if (process.env.NODE_ENV !== '') {
    }
}

const request = (() => {
    const options = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        // baseURL: baseURL,
        timeout: 15000,
    }

    const instance = Axios.create(options)
    instance.interceptors.response.use(
        (response) => {
            const {code, message, msg, data} = response.data
            const {intact, okMsg} = response.config
            // 返回完整数据
            if (intact) {
                return response.data
            }

            if (code != 200 && code != 202) {
                if (code === 401) {
                } else {
                    showMsg(message || msg)
                    return data
                }
            } else {
                if (okMsg) {
                    showMsg(okMsg)
                }
                return data
            }
        },
        (error) => {
            console.log('=========error===========', JSON.stringify(error))
            console.log(response)
            const {response = {}, message} = error
            const {config = {}, status} = response
            showMsg(ERROR_TYPE[
                    (ERROR_CODE.find((ele) => ele.code == status) || {}).msg
                    ] ||
                config.errMsg ||
                message)
        }
    )

    return ({url, params = {}, headers = {}, method = METHODS.GET, opts}) => {
        const {okMsg = '', intact = false} = opts
        const insOptions = {
            ...headers,
            method,
        }

        if (method === METHODS.POST) {
            insOptions.data = params
        } else if (method === METHODS.GET) {
            insOptions.params = params
        }

        return instance.request({url, ...insOptions, intact})
    }
})()

export const get = (url, params, opts = {}) => request({url, params, opts})

export const post = (url, params, opts = {}) =>
    request({
        url,
        params,
        method: METHODS.POST,
        opts,
    })
